import React, { useState, useEffect, useRef } from 'react';
import COUNTRY_CODES from './countryCodes';

function getFlag(iso) {
  return iso.toUpperCase().split('').map(function(c) {
    return String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65);
  }).join('');
}

function CountryCodePicker(props) {
  var value = props.value;
  var onChange = props.onChange;
  var disabled = props.disabled;
  var phone = props.phone;
  var onPhoneChange = props.onPhoneChange;

  var [open, setOpen] = useState(false);
  var [search, setSearch] = useState('');
  var ref = useRef(null);
  var searchRef = useRef(null);

  var selected = COUNTRY_CODES.find(function(c) { return c.code === value; }) || COUNTRY_CODES[0];

  var filtered = search.trim().length === 0
    ? COUNTRY_CODES
    : COUNTRY_CODES.filter(function(c) {
        return c.name.toLowerCase().includes(search.toLowerCase()) || c.code.includes(search);
      });

  useEffect(function() {
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    }
    document.addEventListener('mousedown', handler);
    return function() { document.removeEventListener('mousedown', handler); };
  }, []);

  useEffect(function() {
    if (open && searchRef.current) {
      searchRef.current.focus();
    }
  }, [open]);

  function handleToggle() {
    if (!disabled) {
      setOpen(function(prev) { return !prev; });
      setSearch('');
    }
  }

  function handleSelect(code) {
    onChange(code);
    setOpen(false);
    setSearch('');
  }

  return (
    <div className="phone-single-field" ref={ref}>
      {/* Selector de país — parte izquierda */}
      <button
        type="button"
        className="country-picker-trigger"
        onClick={handleToggle}
        disabled={disabled}
      >
        <span className="cpicker-flag">{getFlag(selected.iso)}</span>
        <span className="cpicker-code">{selected.code}</span>
        <span className="cpicker-arrow">▾</span>
      </button>

      {/* Divisor */}
      <span className="phone-field-divider" />

      {/* Input del número — parte derecha */}
      <input
        name="phone"
        value={phone}
        className="phone-field-input"
        placeholder="INGRESA TU NÚMERO"
        id="phone"
        onChange={onPhoneChange}
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        disabled={disabled}
        autoComplete="off"
      />

      {/* Dropdown de países */}
      {open && (
        <div className="cpicker-dropdown">
          <div className="cpicker-search-wrap">
            <input
              ref={searchRef}
              type="text"
              className="cpicker-search"
              placeholder="Buscar país o código..."
              value={search}
              onChange={function(e) { setSearch(e.target.value); }}
            />
          </div>
          <ul className="cpicker-list">
            {filtered.length === 0 && (
              <li className="cpicker-empty">Sin resultados</li>
            )}
            {filtered.map(function(c) {
              return (
                <li
                  key={c.iso}
                  className={'cpicker-item' + (c.code === value ? ' is-selected' : '')}
                  onMouseDown={function() { handleSelect(c.code); }}
                >
                  <span className="cpicker-item-flag">{getFlag(c.iso)}</span>
                  <span className="cpicker-item-code">{c.code}</span>
                  <span className="cpicker-item-name">{c.name}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}

export default CountryCodePicker;
